import React, { useEffect, useState, useRef, useContext } from 'react'
import axios from 'axios';
import Settings from "../../../AppSettings";
import ServiceSurvey from '../../../services/survey';
import ServiceAI from '../../../services/ai';
import ServiceQuestion from '../../../services/question';
import CustomRadarChart from '../chart/radarchart';
import { Context } from '../../../AppContext';
import { RadialChart } from 'react-vis';
import { Button, CheckBox, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from '../../ui/core';
import ReactDOMServer from 'react-dom/server'
export default function Generate({ survey, onClose }) {
    const context = useContext(Context);
    const [charts, setCharts] = useState([])
    const [postData, setPostData] = useState();

    const [showSummary, setShowSummary] = useState(true);
    const [showGeneralResults, setShowGeneralResults] = useState(true);
    const [showDetailResults, setShowDetailResults] = useState(true);
    const [showAttachmentPerQuestion, setShowAttachmentPerQuestion] = useState(true);
    const [showEvaluations, setShowEvaluations] = useState(true);
    const [showFindings, setShowFindings] = useState(true);
    const [isGenerating, setIsGenerating] = useState(false);
    const [useAI, setUseAI] = useState(false);
    const [aiInfo, setAIIntro] = useState({});
    const [opacity, setOpacity] = useState(1);
    const [aiSummaryState, setAISummaryState] = useState("Nog niet gestart");
    const [aiFindingsState, setAIFindingsState] = useState("Nog niet gestart");
    const [aiIntrostate, setAIIntroState] = useState("Nog niet gestart");

    const ref = useRef();

    const locationAPI = Settings.getLocationOpenDocumentAPI();

    const downloadBase64File = (base64Data, fileName) => {
        const linkSource = `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const createCharts = async () => {
        let questions = [];
        try { questions = await ServiceQuestion.getForSurvey(survey._id); } catch (ex) { console.log(ex) }




        let scores = await ServiceSurvey.getScores(survey._id);
        let scoresDetail = await ServiceSurvey.getScoresDetail(survey._id);

        //for testing AI
        let findProcessName = (id) => {
            let title = '-';
            survey.mainProcesses && survey.mainProcesses.forEach(m => {
                if (m._id == id) {
                    title = m.title;
                }
                m.subProcesses && m.subProcesses.forEach(s => {
                    if (s._id == id) {
                        title = s.title;
                    }
                })
            });
            return title;
        }

        let getScore = (id) => {
            let score = scores.questionsScore.find(s => { return s._id == id });
            if (score) {
                return score.perc;
            }
            return -1;
        }

        let newQuestions = questions.map(q => {
            return { _id: q._id, question: q.question, subProcess: q.subProcess, score: getScore(q._id) }
        })


        console.log({
            questions: newQuestions,
            mainProcessScore: scores.mainProcessScore.map(s => { s.name = findProcessName(s._id); return { _id: s._id, name: s.name, score: s.perc } }),
            subProcessScore: scores.subProcessScore.map(s => { s.name = findProcessName(s._id); return { _id: s._id, name: s.name, score: s.perc } }),
        })
        setAIIntro({
            questions: newQuestions,
            mainProcessScore: scores.mainProcessScore.map(s => { s.name = findProcessName(s._id); return { _id: s._id, name: s.name, score: s.perc } }),
            subProcessScore: scores.subProcessScore.map(s => { s.name = findProcessName(s._id); return { _id: s._id, name: s.name, score: s.perc } }),
        })
        //end for testing AI


        let opentext = scoresDetail.openText || [];
        let closedValues = scoresDetail.closedValues || [];
        let openValues = scoresDetail.openValues || [];

        let mainProcessScore = scores.mainProcessScore || [];
        let subProcessScore = scores.subProcessScore || [];

        let tmpCharts = [];
        //main process score chart
        survey.mainProcesses.filter(p => { return p.active === true }).forEach(mainProcess => {
            let tmpScores = [];

            if (mainProcess && mainProcess.subProcesses) {

                for (let t = 0; t < mainProcess.subProcesses.length; t++) {

                    if (mainProcess.subProcesses[t].active === true) {

                        let tmpScore = {};
                        tmpScore._id = mainProcess.subProcesses[t]._id;
                        tmpScore.title = mainProcess.subProcesses[t].title;
                        tmpScore.score = 0;
                        let score = subProcessScore.find(i => { return i._id === mainProcess.subProcesses[t]._id });
                        if (score) {
                            tmpScore.score = score.perc;
                            tmpScore.color = ServiceSurvey.getColorFromRange(survey.colorRange, score.perc);
                        }
                        tmpScore.max = 100;
                        tmpScores.push(tmpScore);
                    }
                }
            }
            let chart = <CustomRadarChart id={mainProcess._id} key={mainProcess._id} scores={tmpScores} colorRange={survey.colorRange} />

            tmpCharts.push(chart);
        })

        //question chart
        questions.forEach(question => {
            if (question.options) {
                question.options = question.options.filter(q => { return q.active === true })
                scores = closedValues.filter(s => { return s.value >= 0 && s.question == question._id });

                if (scores.length === 0) {
                    return null;
                }
                let data = [];
                let bri = 1;
                let briSteps = 1 / question.options.filter(s => { return s.score >= 0 }).length;
                if (question.options) {
                    for (let i = 0; i < question.options.length; i++) {
                        if (question.options[i].score >= 0) {
                            ///console.log( ServiceColor.changeHue("#00698f",hue))
                            let foundScores = scores.filter(s => { return s.value === question.options[i].score })
                            data.push({ id: question.options[i]._id, angle: foundScores.length, style: { fill: `rgba(0,105,143,${bri})`, stroke: `rgba(0,105,143,${bri})` }, colorType: "literal", label: (Math.round(((100 / scores.length) * foundScores.length) * 10) / 10) + '%', text: question.options[i].text })
                            bri = bri - briSteps;//0.2
                        }
                    }
                }

                question.chartData = data;
                let chart = <div id={question._id} key={question._id} ><RadialChart showLabels={true} data={data} labelsRadiusMultiplier={0.9} labelsStyle={{ fontSize: "11px", fill: "white", backgroundColor: "black" }} width={200} height={200} /></div>
                tmpCharts.push(chart);
            }

        })

        setCharts(tmpCharts);


        let postData = {
            title: survey.title || "",
            colorRange: survey.colorRange,
            subTitle: "",
            author: "",
            showAttachmentPerQuestion: true,
            intro: "In dit document...",
            summary: "Samengevat is het .",
            mainProcesses: survey.mainProcesses.filter(p => { return p.active === true }),
            // mainProcesses:[{code:"1",title:"Process 1",description:"Beschrijving bij process 1"},{code:"2",title:"Process 2",image:""}],
            // subProcesses: [{ code: "a", title: "Sub Process A", mainProcessCode: "1" }, { code: "b", title: "Sub Process b", mainProcessCode: "1" }],
            mainProcessScore: mainProcessScore,// [{ _id: "1", perc: 60 }, { _id: "2", perc: 70 }],
            subProcessScore: subProcessScore,// [{ _id: "a", perc: 55 }, { _id: "b", perc: 79 }],
            questions: questions,//[{_id:"1",question:"Is opgeschaald op ..",sort:"1"},{_id:"2",question:"Is afgeschaald op ..",sort:"2",image:""}],
            opentext: opentext,//[{question:"1",openText:"De waarneming is .."},{question:"2",openText:"De bevinding is .."}],//waarnemingen
            closedValues: closedValues,//[{question:"1",perc:80},{question:"2",perc:70}]
            openValues: openValues
        }
        setPostData(postData);
    }

    useEffect(() => {
        createCharts();
    }, [])


    const requestAIStatus = (ticket) => {
        return new Promise((resolve, reject) => {
            ServiceAI.status(ticket).then(
                result => {
                    resolve(result);
                },
                error => {
                    reject(error);
                }
            );
        });
    }

    const requestAIContent = async (data, responseID) => {
        return new Promise((resolve, reject) => {
            let question = ""
            switch (data) {
                case "intro":
                    question = `Gebruik in je antwoord geen tabel. Maak geen tabellen op. Antwoord in het Nederlands. Maak een inleidende tekst voor dit onderzoek. Gebruik hiervoor de volgende processen en vragenlijst als input: ${JSON.stringify(aiInfo)}`
                    ServiceAI.newRequest({ question: question, response_id: responseID }).then(
                        result => {
                         //   console.log(result);
                            resolve(result);
                        })
                    break;
                case "samenvatting":
                    question = `Gebruik in je antwoord geen tabel. Maak geen tabellen op. Antwoord in het Nederlands. Geef een samenvatting van waar het onderzoek over gaat.  Gebruik hiervoor de  processen, vragen en scores.`
                    ServiceAI.newRequest({ question: question, response_id: responseID }).then(
                        result => {
                        //    console.log(result);
                            resolve(result);
                        })
                    break;
                case "findings":
                    question = `Gebruik in je antwoord geen tabel. Maak geen tabellen op. Antwoord in het Nederlands. Wat zijn de bevindingen op basis van de resultaten van het onderzoek? Geef aan wat de sterke punten zijn en wat de verbeterpunten zijn. Geef ook aan welke processen het beste scoren en welke processen minder goed scoren.`
                    ServiceAI.newRequest({ question: question, response_id: responseID }).then(
                        result => {
                         //   console.log(result);
                            resolve(result);
                        })
                    break;
                default:
                    reject("Onbekende data gevraagd aan AI");
                    break;
            }

        });
    }

    // Helper function to create a delay
    const delay = (seconds) => {
        return new Promise(resolve => setTimeout(resolve, seconds * 1000));
    };

    const star = <svg width="30" height="38" style={{ paddingRight: '6px' ,paddingLeft:'40px'}} viewBox="0 0 40 48" xmlns="http://www.w3.org/2000/svg">
        <path fill="#cf2e26" d="M20 2 C20 2 21.2 14 24 17 C27 20 38 20 38 20 C38 20 27 21.2 24 24 C21.2 27 20 38 20 38 C20 38 18.8 27 16 24 C13 21.2 2 20 2 20 C2 20 13 18.8 16 17 C18.8 14 20 2 20 2 Z"></path>

        <circle cx="9" cy="9" r="3" fill="#cf2e26" opacity={opacity} style={{ transition: 'opacity 5s ease' }}></circle>
        <circle cx="9" cy="29" r="1.5" fill="#cf2e26" opacity="0.5"></circle>
    </svg>

    const handleDownload = async () => {
        if (postData && ref.current) {
            setIsGenerating(true);
            let textIntro = "";
            let textSummary = "";
            let textFindings = "";
            if (useAI) {
              
                let result;
                let response_id = "";

                result = await requestAIContent('intro');
                while (true) {
                    let status = await requestAIStatus(result.ticket);
                    setAIIntroState(status.message + "...");
                    setOpacity((Math.floor(Math.random() * (10 - 0 + 1)) + 0) / 10);
                    response_id = status.response_id;
                  
                    if (status.response_id) {
                        setAIIntroState("Aanvraag verwerkt"); 
                        textIntro = status.answer;
                        break;
                    }
                    await delay(5);
                }

                if (showSummary) {
                    result = await requestAIContent('samenvatting', response_id);
                    while (true) {
                        let status = await requestAIStatus(result.ticket);
                        setAISummaryState(status.message + "...");
                        setOpacity((Math.floor(Math.random() * (10 - 0 + 1)) + 0) / 10);
                        //response_id = status.response_id;
                       
                        if (status.response_id) {
                            setAISummaryState("Aanvraag verwerkt");
                            textSummary = status.answer;
                            break;
                        }
                        await delay(5);
                    }
                }


                if (showFindings) {
                    result = await requestAIContent('findings', response_id);
                    while (true) {
                        let status = await requestAIStatus(result.ticket);
                        setAIFindingsState(status.message + "...");
                     
                        if (status.response_id) {
                            setAIFindingsState("Aanvraag verwerkt");
                            textFindings = status.answer;
                            break;
                        }
                        await delay(5);
                    }
                }
            }

            let tmpPostData = Object.assign({}, postData);
            tmpPostData.headerImage = context.organisation.headerImage || "";
            tmpPostData.footerImage = context.organisation.footerImage || "";
            tmpPostData.textIntro = textIntro;
            tmpPostData.textSummary = textSummary;
            tmpPostData.textFindings = textFindings;
            tmpPostData.showSummary = showSummary;
            tmpPostData.showGeneralResults = showGeneralResults;
            tmpPostData.showDetailResults = showDetailResults;
            tmpPostData.showEvaluations = showEvaluations;
            tmpPostData.showFindings = showFindings;
            tmpPostData.showAttachmentPerQuestion = showAttachmentPerQuestion;
            tmpPostData.mainProcesses.forEach(process => {
                let chart = Array.from(ref.current.children).find(child => { return child.id == process._id });
                if (chart) {
                    //   console.log(chart.outerHTML)
                    process.image = "data:image/svg+xml;base64," + window.btoa(chart.outerHTML);
                }
            })
            tmpPostData.questions.forEach(question => {
                let chart = Array.from(ref.current.children).find(child => { return child.id == question._id });
                if (chart) {
                    question.image = "data:image/svg+xml;base64," + window.btoa(chart.getElementsByTagName("svg")[0].outerHTML);
                }
            })
            axios.post(locationAPI, tmpPostData, {})
                .then(res => {
                    downloadBase64File(res.data, "rapport.docx")
                }, err => {
                    console.log(err);
                })
        }
    }

    if (!context.user) return null;
    return (
        <Dialog onClose={onClose}>
            <DialogTitle ><Typography component="h1">Rapport generator</Typography></DialogTitle>
            <DialogContent>
                Toevoegen aan rapport:<br /><br />
                <CheckBox id="intro" label={`Inleiding`} checked={true} disabled={true}></CheckBox>
                {useAI && <div style={{ display: 'inline-flex', color: 'gray' }}>{star}  {aiIntrostate}</div>}

                <CheckBox id="samenvatting" label={`Samenvatting`} checked={showSummary } onChange={() => { setShowSummary(!showSummary) }}></CheckBox>
                {useAI && showSummary && <div style={{ display: 'inline-flex', color: 'gray' }}>{star}  {aiSummaryState}</div>}
                <CheckBox id="algemeen" label={"Resultaten algemeen"} checked={showGeneralResults} onChange={() => { setShowGeneralResults(!showGeneralResults) }}></CheckBox>

                <CheckBox id="gedetaileerd" label={"Resultaten gedetaileerd"} checked={showDetailResults} onChange={() => { setShowDetailResults(!showDetailResults) }}></CheckBox>

                <CheckBox id="gesprekken" label={"Resultaten evaluatie gesprekken"} checked={showEvaluations} onChange={() => { setShowEvaluations(!showEvaluations) }}></CheckBox>

                <CheckBox id="bevindingen" label={`Bevindingen`} checked={showFindings} onChange={() => { setShowFindings(!showFindings) }}></CheckBox>
                {useAI && showFindings && <div style={{ display: 'inline-flex', color: 'gray' }}>{star}  {aiFindingsState}</div>}

                <CheckBox id="bijlage" label={"Bijlage - beantwoording per vraag"} checked={showAttachmentPerQuestion} onChange={() => { setShowAttachmentPerQuestion(!showAttachmentPerQuestion) }}></CheckBox>


                <div ref={ref} style={{ display: 'none' }}>
                    {charts.map(c => { return c })}
                </div>
            </DialogContent>
            <DialogActions>

                {context.user.ai && <div style={{ float: 'left', paddingLeft: '16px' }}><CheckBox id="ai" label={"Gebruik AI voor het genereren van de teksten (experimenteel)"} checked={useAI} onChange={() => { setUseAI(!useAI) }}></CheckBox></div>}

                <Button onClick={handleDownload} disabled={!ref.current || isGenerating}>Rapport aanmaken & downloaden</Button>
                <Button onClick={onClose} style={{ backgroundColor: '#ff6A13' }}>Sluiten</Button>
            </DialogActions>
        </Dialog>
    )
}
